import { Trans } from '@lingui/macro'
import { usePool } from '../../hooks/usePools'
import { Currency } from '@uniswap/v3-core'
import { computePoolAddress } from '../../hooks/computePoolAddress'
import { useActiveWeb3React } from '../../hooks/web3'
import { POOL_DEPLOYER_ADDRESS, FINITE_FARMING_ADDRESS } from '../../constants/addresses'
import { useInfiniteFarmingIncentives } from '../../hooks/useStakerIncentives'

import JSBI from 'jsbi'
// import { BigNumber, FixedNumber } from 'ethers'
import { useAllTransactions } from '../../state/transactions/hooks'
import { useEffect, useMemo, useState } from 'react'
import Loader from '../../components/Loader'
import { useHistory } from 'react-router-dom'

import BigNumber from 'bignumber.js'
import { formatEther, formatUnits } from '@ethersproject/units'
import { parseUnits } from 'ethers/lib/utils'
import Modal from '../../components/Modal'

import { CopyToClipboard } from 'react-copy-to-clipboard'
import styled from 'styled-components/macro'
import { Tiers } from '../Staking/CreateIncentive'

const Link = styled.a`
padding: 8px; 16px;
border-radius: 8px;
width: 100%;
display: flex;
justify-content: center;
text-decoration: none;

&:not(:last-of-type) {
  margin-right: 1rem;
}
`

export function CreateInfiniteFarming({
  currencyA,
  currencyB,
  tokenRewardAddress,
  reward,
  bonusRewardAddress,
  bonusReward,
  rewardRate,
  bonusRewardRate,
  lockedToken,
  tierLimits,
  tierMultipliers,
  isTierFarming,
  minimalRange
}: {
  currencyA: Currency
  currencyB: Currency
  tokenRewardAddress: Currency
  reward: string
  bonusRewardAddress: Currency
  bonusReward: string
  rewardRate: string
  bonusRewardRate: string
  lockedToken: any
  tierLimits: Tiers
  tierMultipliers: Tiers
  isTierFarming: boolean
  minimalRange: string
}) {
  const { account, chainId } = useActiveWeb3React()

  const poolDeployerAddress = chainId && POOL_DEPLOYER_ADDRESS[chainId]

  const poolAddress = computePoolAddress({
    poolDeployer: poolDeployerAddress,
    tokenA: currencyA.wrapped,
    tokenB: currencyB.wrapped,
  })

  const _reward = parseUnits(reward.toString(), tokenRewardAddress.wrapped.decimals).toString()
  const _bonusReward = parseUnits(bonusReward.toString(), bonusRewardAddress.wrapped.decimals).toString()
  const _rewardRate = parseUnits(rewardRate.toString(), tokenRewardAddress.wrapped.decimals).toString()
  const _bonusRewardRate = parseUnits(bonusRewardRate.toString(), bonusRewardAddress.wrapped.decimals).toString()

  const allTransactions = useAllTransactions()

  const sortedRecentTransactions = useMemo(() => {
    const txs = Object.values(allTransactions)
    return txs
      .filter((tx) => new Date().getTime() - tx.addedTime < 86_400_000)
      .sort((a, b) => b.addedTime - a.addedTime)
  }, [allTransactions])

  const confirmed = useMemo(
    () => sortedRecentTransactions.filter((tx) => tx.receipt).map((tx) => tx.hash),
    [sortedRecentTransactions, allTransactions]
  )

  const { createIncentiveTx, createdHash } = useInfiniteFarmingIncentives({
    rewardAddress: tokenRewardAddress.wrapped.address,
    bonusRewardAddress: bonusRewardAddress.wrapped.address,
    poolAddress,
    reward: _reward,
    bonusReward: _bonusReward,
    rewardRate: _rewardRate,
    bonusRewardRate: _bonusRewardRate,
    lockedToken,
    tierLimits,
    tierMultipliers,
    isTierFarming,
    minimalRange
  })

  const history = useHistory()

  useEffect(() => {
    if (!createdHash) return

    if (createdHash === 'failed') {
      //   toggleDisabled()
    } else if (confirmed?.includes(createdHash)) {
      history.push('/farming/future-events')
    }
  }, [createdHash, confirmed])

  return (
    <>
      <button
        onClick={() => {
          if (!createdHash || createdHash === 'failed') {
            createIncentiveTx()
          }
        }}
        style={{
          width: '100%',
          height: '2.8rem',
          background: '#601FB3',
          color: 'white',
          border: 'none',
          borderRadius: '10px',
          fontSize: '16px',
          fontFamily: 'Inter',
        }}
      >
        {createdHash && confirmed.includes(createdHash) ? (
          <Trans>Created!</Trans>
        ) : createdHash && !confirmed.includes(createdHash) && createdHash !== 'failed' ? (
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Loader
              style={{
                display: 'block',
              }}
              stroke={'white'}
            />
            <span
              style={{
                marginLeft: '10px',
              }}
            >
              Creating
            </span>
          </span>
        ) : (
          <Trans>Create incentive</Trans>
        )}
      </button>
    </>
  )
}
